import {Component, inject} from '@angular/core';
import {DataSources} from "@services";
import {OrderLinesGridComponent} from "./order-lines-grid.component";

@Component({
    selector: 'app-order-lines',
    standalone: true,
    imports: [OrderLinesGridComponent],
    template: `<app-order-lines-grid [dataSource]="dataSource"></app-order-lines-grid>`
})
export class OrderLinesComponent {
    private dataSources = inject(DataSources);

    dataSource = this.dataSources.orderLines();
}
